import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  Select,
  Menu,
  IconButton,
  Checkbox,
  FormControl,
  Autocomplete,
  ListSubheader,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";
import { CiEdit } from "react-icons/ci";
// import SearchBar from "../../SearchBar";
import { CiViewList } from "react-icons/ci";
import { Modal, Offcanvas } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { IoIosArrowBack } from "react-icons/io";
import { ExpandMore } from "@mui/icons-material";
import { newFilterEntities, postResource,} from "../../apis/apiService";
import { format } from "date-fns";
import { toast } from "react-toastify";
import Loader, { BtnLoader } from "../../components/common/Loader";
// import { renderOverviewCell } from "../../../utils/mapOverviewData";
import { useSelector } from "react-redux";
import {
  useFetchGetAllProjectBasedUserNameListQuery,
  useFetchMasterAllStatusQuery,
  useFetchMilestoneModuleQuery,
  useFetchMilestoneNamesQuery,
  useFetchUserAccessedProjectsQuery,
} from "../../slice/logdetailSlice";
import apiSlice from "../../slice/logdetailSlice";
import { useDispatch } from "react-redux";
import { CustomNoRowsOverlay } from "../../components/common/OverlayGrid";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import CommonDeleteDialog from "../../components/common/CommonDelete";
import SearchBar from "../../components/SearchBar";
import { renderOverviewCell } from "../../utils/mapOverviewData";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { usePersistentFilter } from "../../assets/hooks/usePersistentFilter";
import dayjs from "dayjs";
import { useTheme } from "../../ThemeContext";
import { openInNewTab } from "../../utils/openInNewTab";


const MilestoneFilterComponent = ({ onApply, onClear, onCancel }) => {
  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      projectName: "",
      Owner: "",
      Status: "",
      startDate: null,
      endDate: null,
    },
  });
  const [loading, setLoading] = useState(false);
  const project_id = localStorage.getItem("project_id");
  const { data: milestoneNames, } = useFetchMilestoneNamesQuery(project_id);
  // //console.log()("milestoneNames_list", milestoneNames);

  const usersInProjects = useSelector(
    (state) => state.selectOptions?.userNamesByProjects,
  );
  // //console.log()("userNamesByProjects", usersInProjects);

  const activestatus = useSelector(
    (state) => state.selectOptions.StatusOptions,
  );
  const activityStatus = activestatus.find(
    (status) => status.status_type === "MILESTONE",
  );
  const statusList = activityStatus?.status_details.map((status) => ({
    id: status.status_id,
    status_name: status.status_name,
    status_colour: status.status_colour,
  }));
  const onSubmit = async (data) => {
    // //console.log()(data);
    setLoading(true);
    const requestedData = {
      name: data.projectName,
      added_by: data.Owner,
      current_status_id: data.Status,
      start_date: data.startDate
        ? format(new Date(data.startDate), "yyyy-MM-dd")
        : null,
      end_date: data.endDate
        ? format(new Date(data.endDate), "yyyy-MM-dd")
        : null,
    };
    // //console.log()("requested data :", requestedData);
    // const
    try {
      const response = await newFilterEntities(
        "milestones/filter",
        project_id,
        requestedData,
      );
      if (response.data) {
        toast.success(response.message);
        // //console.log()("filtered projects : ", response.data);
        onApply(response.data);
      }
    } catch (error) {
      console.error("Failed to filter projects:", error);
      const errorMsg = error.message;
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    reset();
  };

  return (
    <div className="">
      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex text-rgba-gray align-items-center">
            <IoIosArrowBack />
            Filter
          </div>
        </button>
        <div>
          <button
            type="button"
            onClick={handleClear}
            className="R_btn tex-tgba-red"
          >
            Clear Filter
          </button>
        </div>
      </div>
      <div className="bg-white px-4 py-3">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="">
              <div className="row mb-3">
                <div className="col-md-12">
                  <div className="row">
                    <div className="row mb-3">
                      <div className="col-12">
                        <label htmlFor="projecttitle" className="form-label">
                          Filter by milestones
                        </label>
                        <Controller
                          name="projectName"
                          control={control}
                          render={({ field: { onChange, value } }) => (
                            <Autocomplete
                              multiple
                              id="projectName"
                              options={milestoneNames}
                              disableCloseOnSelect
                              getOptionLabel={(option) => option.name}
                              value={
                                (value || []).map((name) =>
                                  milestoneNames.find(
                                    (user) => user.name === name,
                                  ),
                                ) || []
                              }
                              onChange={(event, newValue) => {
                                const selectedTitles = newValue.map(
                                  (user) => user.name,
                                );
                                onChange(selectedTitles);
                              }}
                              renderOption={(props, option, { selected }) => (
                                <li
                                  {...props}
                                  className="d-flex align-items-center mb-2"
                                >
                                  <Checkbox
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                  />
                                  <strong>{option.name}</strong>
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Filter by milestones"
                                />
                              )}
                              ListboxProps={{
                                style: {
                                  display: "grid",
                                  gridTemplateColumns: "1fr 1fr",
                                  gap: "8px",
                                  paddingLeft: "0",
                                },
                              }}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="Owner" className="form-label">
                    Owner
                  </label>

                  <Controller
                    control={control}
                    name="Owner"
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          {...field}
                          IconComponent={ExpandMore}
                          value={field.value || ""}
                          displayEmpty
                          // onChange={(e) => {
                          //   field.onChange(e.target.value); // Update form state
                          //   // setValue("status", e.target.value); // Optionally set value
                          // }}
                          renderValue={(selected) =>
                            selected ? (
                              usersInProjects.find(
                                (namelist) => namelist.user_id === selected,
                              )?.name
                            ) : (
                              <span className="lightText">Select owner</span>
                            )
                          }
                        >
                          {usersInProjects.map((ownerName, index) => (
                            <MenuItem key={index} value={ownerName.user_id}>
                              {ownerName.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="Status" className="form-label">
                    Status
                  </label>
                  <FormControl fullWidth>
                    <Controller
                      name="Status"
                      control={control}
                      render={({ field }) => (
                        <Select
                          {...field}
                          value={field.value || ""}
                          onChange={(e) => {
                            field.onChange(e.target.value); // Update form state
                            // setValue("status", e.target.value); // Optionally set value
                          }}
                          displayEmpty
                          renderValue={(selected) => {
                            const selectedValue = statusList?.find(
                              (statusName) => statusName.id === selected,
                            );
                            return selectedValue ? (
                              <span
                                style={{ color: selectedValue.status_colour }}
                              >
                                {selectedValue.status_name}
                              </span>
                            ) : (
                              <span className="lightText">Select status</span>
                            );
                          }}
                          IconComponent={ExpandMoreIcon}
                        >
                          {statusList.map((status, index) => (
                            <MenuItem
                              key={index}
                              sx={{ color: status.status_colour || "black" }}
                              value={status.id}
                            >
                              {status.status_name}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />
                  </FormControl>
                </div>
              </div>
              <div className="row paddingBtn">
                <div className="col-md-6 pt-3">
                  <label htmlFor="startDate" className="form-label">
                    Start Date
                  </label>
                  <div className="d-flex  flex-column w-100">
                    <Controller
                      name="startDate"
                      control={control}
                      render={({ field }) => (
                        <DatePicker
                          {...field}
                          className="datepicker_input"
                          format="DD/MM/YYYY"
                          onChange={(date) => field.onChange(date)}
                          renderInput={(params) => (
                            <input
                              className="form-control datepicker_input"
                              {...params}
                            />
                          )}
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="col-md-6 pt-3">
                  <label htmlFor="endDate" className="form-label">
                    End Date
                  </label>
                  <Controller
                    name="endDate"
                    control={control}
                    render={({ field }) => (
                      <DatePicker
                        {...field}
                        format="DD/MM/YYYY"
                        onChange={(date) => field.onChange(date)}
                        renderInput={(params) => (
                          <input
                            className="form-control datepic_ip"
                            {...params}
                          />
                        )}
                      />
                    )}
                  />
                </div>
              </div>
              <div className="d-flex bg-white justify-content-start position-absolute w-100 bottom-0 mt-3 py-2">
                <button
                  type="submit"
                  className="add_btn me-3"
                  disabled={loading}
                >
                  {loading ? "Applying..." : "Apply"}
                </button>
                <button type="button" className="cancel_btn" onClick={onCancel}>
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};

export const AddMilestoneComponent = ({
  fetchMilestone,
  onApply,
  onClear,
  onCancel,
}) => {
  const [selectedProject, setSelectedProject] = useState(null);
  const { data: user_accessed_project } = useFetchUserAccessedProjectsQuery();
  const [cloneMilestoneId, setCloneMilestoneId] = useState(0);
  const {
    handleSubmit,
    control,
    reset,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: {
      MilestoneName: "",
      owner: "",
      StartDate: null,
      EndDate: null,
      project: null,
      Milestone: null,
      project_id: null,
    },
  });
  const [loading, setLoading] = useState(false);
  const projectNames = useSelector(
    (state) => state.selectOptions.ProjectNameOptions,
  );
  // //console.log()("task_filter_project name: ", projectNames);
  const { data: usersInProjects } =
    useFetchGetAllProjectBasedUserNameListQuery(selectedProject);
  // //console.log()("userNamesByProjects", usersInProjects);
  const {
    data: projectData,
    refetch,
    isLoading,
  } = useFetchMilestoneNamesQuery(selectedProject);

  // //console.log()("milestoneNamesByProject_updated :", projectData);
  const handleAddMore = (e) => {
    e.preventDefault();
    handleSubmit((data) => addMoreMilestones(data))();
  };
  const addMoreMilestones = async (data) => {
    setLoading(true);
    const requestData = {
      milestone_name: data.MilestoneName,
      owner_id: data.owner,
      // project_id: data.project_id,
      start_date: data.StartDate
        ? format(new Date(data.StartDate), "yyyy-MM-dd")
        : null,
      end_date: data.EndDate
        ? format(new Date(data.EndDate), "yyyy-MM-dd")
        : null,
      project_id: data.project,
      clone_milestone_id: data.Milestone,
    };
    try {
      // Call the API to create the entity
      const response = await postResource(
        "milestones",
        "add",
        selectedProject,
        requestData,
      );
      toast.success(response.message);
      onClear();
      fetchMilestone();
    } catch (error) {
      toast.error(error.message || error.response.data.message);
    } finally {
      setLoading(false);
    }
  };
  const onSubmit = async (data) => {
    setLoading(true);
    const requestData = {
      milestone_name: data.MilestoneName,
      owner_id: data.owner,
      // project_id: data.project_id,
      start_date: data.StartDate
        ? format(new Date(data.StartDate), "yyyy-MM-dd")
        : null,
      end_date: data.EndDate
        ? format(new Date(data.EndDate), "yyyy-MM-dd")
        : null,
      selectedProject: data.project,
      clone_milestone_id: data.Milestone,
    };
    try {
      // Call the API to create the entity
      const response = await postResource(
        "milestones",
        "add",
        selectedProject,
        requestData,
      );
      toast.success(response.message);
      onCancel();
      fetchMilestone();
      //  fetchIssues();
    } catch (error) {
      toast.error(error.message || error.response.data.message);
    } finally {
      setLoading(false);
    }
  };
  const handleCheckboxChange = (event) => {
    setCloneMilestoneId(event.target.checked ? 1 : 0); // Update state based on checkbox
  };


  
  return (
    <div className="">
      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex text-rgba-gray align-items-center">
            <IoIosArrowBack />
            Add New Milestone
          </div>
        </button>
      </div>
      <div className="bg-white px-4 py-3">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <div className="row mb-3">
                <div className="col-md-12">
                  <label htmlFor="project_id" className="form-label">
                    Project name <span className="errorMsg">*</span>
                  </label>
                  <Controller
                    name="project_id"
                    control={control}
                    rules={{ required: "Project field is required" }}
                    render={({
                      field: { onChange, value },
                      formState: { errors },
                    }) => (
                      <>
                        <Autocomplete
                          id="project_id"
                          options={
                            Array.isArray(user_accessed_project)
                              ? user_accessed_project
                              : []
                          }
                          getOptionLabel={(option) => option.title}
                          value={
                            user_accessed_project?.find(
                              (user) => user.project_id === value,
                            ) || null
                          }
                          onChange={(event, newValue) => {
                            if (newValue) {
                              if (Array.isArray(newValue)) {
                                toast.error("You can select only one project.");
                              } else {
                                onChange(newValue.project_id);
                                setSelectedProject(newValue.project_id); // Set selected user ID
                              }
                            } else {
                              onChange(null);
                              setSelectedProject(null); // Reset selected user ID
                            }
                          }}
                          renderOption={(props, option, { selected }) => (
                            <li
                              {...props}
                              className="d-flex align-items-center mb-2"
                            >
                              <Checkbox
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              <strong>{option.title}</strong>
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select project"
                            />
                          )}
                        />
                        <span className="errorMsg">
                          {errors?.project_id?.message}
                        </span>
                      </>
                    )}
                  />
                </div>
              </div>
              {selectedProject && (
                <>
                  <div className="row">
                    <div className="col-12">
                      <div>
                        <label htmlFor=" MilestoneName " className="form-label">
                          Milestone Name
                          <span className="errorMsg"> *</span>
                        </label>
                        <TextField
                          type="text"
                          id="MilestoneName"
                          placeholder="Enter milestone name"
                          className="form-control"
                          {...register("MilestoneName", {
                            required: "Milestone name is required",
                          })}
                        />
                        {errors.MilestoneName && (
                          <span className="errorMsg">
                            {errors.MilestoneName.message}
                          </span>
                        )}
                      </div>

                      {/* <Checkbox
                    checked={cloneMilestoneId === 1}
                    onChange={handleCheckboxChange}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <label className="text-rgbr-blue">
                    Clone from Existing Milestone
                  </label> */}
                    </div>
                  </div>
                  {/* {cloneMilestoneId === 1 && (
                <div className="row">
                  <div className="col-md-12">
                    <label htmlFor=" Project " className="form-label">
                      Project
                    </label>
                    <Autocomplete
                      disablePortal
                      options={projectNames}
                      id="project"
                      getOptionLabel={(option) => option.title}
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select project" />
                      )}
                    />
                  </div>
                  <div className="col-md-12 pt-3">
                    <label htmlFor=" Milestone " className="form-label">
                      Milestone
                    </label>
                    <Autocomplete
                      disablePortal
                      options={projectData}
                      id="Milestone"
                      placeholder="Milestones"
                      getOptionLabel={(option) => option.name}
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select milestone" />
                      )}
                    />
                  </div>
                </div>
              )} */}

                  <div className="row mb-3 pt-3">
                    <div className="col-md-12">
                      <label htmlFor="owner" className="form-label">
                        Owner
                      </label>
                      <span className="text-rgbr-red"> *</span>

                      <Controller
                        name="owner"
                        control={control}
                        rules={{ required: "Owner is required" }}
                        render={({ field }) => (
                          <FormControl fullWidth>
                            <Select
                              {...field}
                              renderValue={(selected) =>
                                selected ? (
                                  usersInProjects?.find(
                                    (owner) => owner.user_id === selected,
                                  )?.name
                                ) : (
                                  <span className="lightText">
                                    Select owner
                                  </span>
                                )
                              }
                              displayEmpty
                            >
                              {usersInProjects?.map((user) => (
                                <MenuItem
                                  key={user.user_id}
                                  value={user.user_id}
                                >
                                  {user.name}
                                </MenuItem>
                              ))}
                            </Select>
                            {errors.owner && (
                              <span className="errorMsg">
                                {errors.owner.message}
                              </span>
                            )}
                          </FormControl>
                        )}
                      />
                    </div>
                  </div>
                  <div className="row paddingBtn">
                    <div className="col-md-6 pt-3">
                      <label htmlFor="Start Date" className="form-label">
                        Start Date
                      </label>
                      <div className="d-flex  flex-column w-100">
                        <Controller
                          name="StartDate"
                          control={control}
                          render={({ field }) => (
                            <DatePicker
                              {...field}
                              format="DD/MM/YYYY"
                              onChange={(date) => field.onChange(date)}
                              renderInput={(params) => (
                                <input className="form-control" {...params} />
                              )}
                            />
                          )}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 pt-3">
                      <label htmlFor="EndDate" className="form-label">
                        End Date
                      </label>
                      <div className="d-flex  flex-column w-100">
                        <Controller
                          name="EndDate"
                          control={control}
                          render={({ field }) => (
                            <DatePicker
                              {...field}
                              format="DD/MM/YYYY"
                              onChange={(date) => field.onChange(date)}
                              renderInput={(params) => (
                                <input className="form-control" {...params} />
                              )}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
              <div
                className="bg-white position-absolute bottom-0
                w-100   p-2"
              >
                <div className="d-flex justify-content-left mt-3">
                  <button
                    type="submit"
                    className="add_btn me-3"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <BtnLoader />
                      </>
                    ) : (
                      "Add"
                    )}
                  </button>
                  <button
                    type="button"
                    className="addmore_btn me-3"
                    disabled={loading}
                    onClick={handleAddMore}
                  >
                    {/* {loading ? (
                      <>
                        Add more
                        <BtnLoader />
                      </>
                    ) : (
                      "Add more"
                    )} */}
                    Add more
                  </button>
                  <button
                    type="button"
                    disabled={loading}
                    className="cancel_btn"
                    onClick={onCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};

const Milestone = () => {
  const { isDarkMode } = useTheme();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [Milestone, setMilestone] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [showProject, setShowProject] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedSubtask, setSelectedSubtask] = useState(null);
  const [checkedMilestones, setCheckedMilestones] = useState({});
  const [expandedRows, setExpandedRows] = useState({});
  const [checkedRows, setCheckedRows] = useState({});
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const {
    data,
    refetch: milestone_status_refetch,
    isLoading,
  } = useFetchMasterAllStatusQuery();
  const [fields, setFields] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const { data: usersInProjects, refetch: project_based_users_refresh } =
    useFetchGetAllProjectBasedUserNameListQuery(selectedTask?.project_id, {
      skip: !selectedTask,
    });

  const [clearFilter, setClearFilter] = useState(false);
  const navigate = useNavigate();
  const ProjectID = localStorage.getItem("project_id");
  const loginUser = useSelector((state) => state.selectOptions?.loginUserName);
  // //console.log()("login_user_detail in redux state: ", loginUser);
  const { name, id: login_user_id, role: login_user_role } = loginUser;
  const [filter, setFilter] = usePersistentFilter(
    "milestoneModuleFilter",
    login_user_role === "CLIENT" || login_user_role === "ADMIN" ? 1 : 6,
  );
  const { reset } = useForm();
  const {
    data: milestone_module,
    refetch: milestone_module_refetch,
    isLoading: milestone_module_loading,
  } = useFetchMilestoneModuleQuery({
    searchText: searchTerm,
    view_type_id: filter,
  });
  const {
    handleSubmit: handleEditSubmit,
    control: editControl,
    reset: editReset,
    register: editRegister,
    formState: { errors: editErrors },
  } = useForm({
    defaultValues: {
      MilestoneName: "",
      owner: "",
      StartDate: null,
      EndDate: null,
    },
  });
  useEffect(() => {
    if (data) {
      const milestoneStatus = data.find(
        (list) => list?.status_type === "MILESTONE",
      );
      if (milestoneStatus) {
        const newFields = milestoneStatus?.status_details.map((status) => ({
          id: status.status_id,
          status_name: status.status_name,
          status_colour: status.status_colour,
        }));

        setFields(newFields);
        if (selectedTask && showEditModal) {
          editReset({
            MilestoneName: selectedTask.name || "",
            owner: selectedTask.owner_id ? Number(selectedTask.owner_id) : "",
            StartDate: selectedTask.start_date
              ? dayjs(selectedTask.start_date)
              : null,
            status_id: selectedTask.status_id
              ? Number(selectedTask.status_id)
              : "",
            EndDate: selectedTask.end_date
              ? dayjs(selectedTask.end_date)
              : null,
          });
        }
      }
    }
  }, [data]);

  useEffect(() => {
    if (selectedTask && showEditModal) {
      project_based_users_refresh();
    }
  }, [selectedTask, showEditModal]);

  useEffect(() => {
    if (selectedTask && showEditModal && fields.length > 0) {
      // console.log("fields at reset time:", fields);
      editReset({
        MilestoneName: selectedTask.name || "",
        owner: selectedTask.owner_id ? Number(selectedTask.owner_id) : "",
        StartDate: selectedTask.start_date
          ? dayjs(selectedTask.start_date)
          : null,
        EndDate: selectedTask.end_date ? dayjs(selectedTask.end_date) : null,
        status_id: Number(selectedTask.status_id),
      });
    }
  }, [selectedTask, showEditModal, fields]);

  // Re-apply owner default once usersInProjects finishes loading
  // (the query fires after selectedTask is set, so the Select options
  //  may not exist yet when the first editReset runs)
  useEffect(() => {
    if (
      selectedTask &&
      showEditModal &&
      Array.isArray(usersInProjects) &&
      usersInProjects.length > 0
    ) {
      const ownerExists = usersInProjects.some(
        (u) => u.user_id === Number(selectedTask.owner_id),
      );
      if (ownerExists) {
        editReset((prev) => ({
          ...prev,
          owner: Number(selectedTask.owner_id),
        }));
      }
    }
  }, [usersInProjects]);
  const numericId =
    parseInt(selectedTask?.id.replace(/\D/g, ""), 10) || selectedTask?.id;
  const toggleRow = (projectId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [projectId]: !prev[projectId],
    }));
  };

  // Handle checkbox selection
  const handleCheckboxChange = (event, row) => {
    event.stopPropagation();
    setCheckedRows((prev) => ({
      ...prev,
      [row.id]: event.target.checked,
    }));
  };
  useEffect(() => {
    milestone_module_refetch();
    milestone_status_refetch();
  }, []);

  // Open menu
  const handleMenuOpen = (event, row) => {
    event.stopPropagation();

    setMenuAnchorEl(event.currentTarget);
    setSelectedTask(row);
  };

  // Close menu
  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    // setSelectedTask(null);
  };
  useEffect(() => {
    // console.log("selectedTask :", selectedTask);
  }, [selectedTask]);
  const onEditSubmit = async (data) => {
    setEditLoading(true);
    const requestData = {
      milestone_name: data.MilestoneName,
      owner_id: data.owner,
      current_status_id: data.status_id,
      start_date: data.StartDate
        ? format(new Date(data.StartDate), "yyyy-MM-dd")
        : null,
      end_date: data.EndDate
        ? format(new Date(data.EndDate), "yyyy-MM-dd")
        : null,
      project_id: selectedTask.project_id,
    };
    try {
      const response = await postResource(
        "milestones",
        "update",
        selectedTask.milestone_id,
        requestData,
      );
      toast.success(response.message);
      setShowEditModal(false);

      // dispatch(apiSlice.util.invalidateTags(["Timesheet"]));
      dispatch(apiSlice.util.invalidateTags(["Timesheet", "Milestone"]));
      sessionStorage.removeItem("timesheet_filter");
      
      milestone_module_refetch();
    } catch (error) {
      toast.error(error.message || error.response?.data?.message);
    } finally {
      setEditLoading(false);
    }
  };

  // Handle menu item click
  const handleMenuClick = (value) => {
    if (selectedTask) {
      const numericId =
        parseInt(selectedTask.id.replace(/\D/g, ""), 10) || selectedTask.id;
      // //console.log()(
      //   `Task ID: ${selectedTask.id}, Task Name: ${selectedTask.name}`
      // );
      // //console.log()("project_id_in_milestone:", selectedTask.parent_id);
      localStorage.setItem("project_id", selectedTask.project_id);
      if (value === true) {
        navigate(
          `/projects/projectDetail/${selectedTask.project_id}/milestone/MilestoneDetail/${numericId}`,
        );
      } else {
        const path = `/projects/projectDetail/${selectedTask.project_id}/milestone/MilestoneDetail/${numericId}`;
        openInNewTab(path);
      }
    }
    handleMenuClose();
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedSubtask(null);
  };
  // //console.log()(
  //   "milestone_add :",
  //   Milestone.map((name) => name.added_by)
  // );
  // //console.log()(login_user_id);

  const rows = [];
  milestone_module?.forEach((project) => {
    // Add parent project row
    rows.push({
      id: `P-ID-${project.project_id}`, // Unique ID for parent row
      project_id: project.project_id,
      name: project.project_name,
      isParent: true, // Flag to differentiate parent rows
    });

    // Add child milestone rows if expanded
    if (expandedRows[project.project_id]) {
      project.milestones.forEach((milestone) => {
        rows.push({
          id: `M-ID-${milestone.milestone_id}`,
          parent_id: project.project_id,
          milestone_id: milestone.milestone_id,
          name: milestone.milestone_title,
          completed_percentage: milestone.completed_percentage,
          owner_name: milestone.owner_name,
          current_status_name: milestone.milestone_status,
          owner_id: milestone?.owner_id,
          status_id: milestone.current_status_id,
          status_colour: milestone.milestone_status_colour,
          start_date: milestone.start_date,
          end_date: milestone.end_date,
          added_by: milestone.added_by,
          task_overview: milestone.task_overview,
          issue_overview: milestone.issue_overview,
          project_id: project.project_id,
          isParent: false, // Mark it as child row
        });
      });
    }
  });

  const columns = [
    {
      field: "actions",
      headerName: "Action",
      width: 120,
      renderCell: (params) => (
        <Box display="flex" alignItems="center">
          {/* Parent Dropdown Icon */}
          {params.row.isParent && (
            <IconButton
              size="small"
              onClick={() => toggleRow(params.row.project_id)}
            >
              {expandedRows[params.row.project_id] ? (
                <ExpandMoreIcon />
              ) : (
                <ChevronRightIcon />
              )}
            </IconButton>
          )}

          {/* Checkbox and MoreHorizIcon for Child Rows */}
          {!params.row.isParent && (
            <Box display="flex" alignItems="center">
              <Checkbox
                checked={!!checkedRows[params.row.id]}
                onChange={(event) => handleCheckboxChange(event, params.row)}
              />
              {checkedRows[params.row.id] && (
                <IconButton
                  onClick={(event) => handleMenuOpen(event, params.row)}
                >
                  <MoreHorizIcon />
                </IconButton>
              )}
            </Box>
          )}
        </Box>
      ),
    },
    { field: "id", headerName: "ID", width: 100 },
    {
      field: "name",
      headerName: "Name",
      width: 200,

      renderCell: (params) => {
        const handleClick = () => {
          if (!params.row.isParent) {
            navigate(
              `/projects/projectDetail/${params.row.parent_id}/milestone/MilestoneDetail/${params.row.milestone_id}`,
            );
          }
        };
        return (
          <Box
            onClick={handleClick}
            sx={{
              fontWeight: params.row.isParent ? "600" : "normal",
              cursor: params.row.isParent ? "default" : "pointer",
            }}
          >
            {params.row.name}
          </Box>
        );
      },
    },
    {
      field: "owner_name",
      headerName: "Owner",
      width: 150,
    },
    {
      field: "current_status_name",
      headerName: "Status",
      width: 180,
      renderCell: (params) =>
        params.row.current_status_name ? (
          <Box
            sx={{
              color: params.row.status_colour || "black",
              padding: "4px 8px",
              borderRadius: "4px",
            }}
          >
            {params.row.current_status_name}
          </Box>
        ) : (
          ""
        ),
    },
    {
      field: "added_by",
      headerName: "Added By",
      width: 150,
      renderCell: (params) => params.row.added_by?.name || "N/A",
    },
    {
      field: "start_date",
      headerName: "Start Date",
      width: 150,
    },
    {
      field: "end_date",
      headerName: "End Date",
      width: 150,
    },
    {
      field: "task_overview",
      headerName: "Task",
      width: 150,
      renderCell: (params) => {
        if (!params.row.isParent) {
          return (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
              width="100%"
            >
              {/* {// //console.log()("paramssssss_of_milestones_overview :", params)} */}
              {renderOverviewCell(params, "task_overview")}
            </Box>
          );
        }
        return null; // Ensure it returns null for parent rows
      },
    },
    {
      field: "issue_overview",
      headerName: "Issues",
      width: 150,
      renderCell: (params) => {
        if (!params.row.isParent) {
          return (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
              width="100%"
            >
              {renderOverviewCell(params, "issue_overview")}
            </Box>
          );
        }
        return null;
      },
    },
  ];
  const fetchSearchedMilestone = async (searchQuery) => {
    setLoading(true);
    try {
      const response = await newFilterEntities(
        "/milestones/search",
        ProjectID,
        {
          search: searchQuery,
        },
      );
      if (response.status) {
        setMilestone(response.data);
      } else {
        setMilestone([]);
      }
    } catch (error) {
      console.error("Failed to fetch Milestone:", error);
      setMilestone([]);
      // Handle the error appropriately in the caller
    } finally {
      setLoading(false);
    }
  };
  const handleShowFilter = () => setShowFilter(true); // Open filter
  const handleShowProject = () => setShowProject(true); // Open filter

  const toggleExpandRow = (taskId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [taskId]: !prev[taskId],
    }));
  };
  const filterOptions = {
    predefined: [
      { label: "All Milestone", value: 1 },
      { label: "All Open", value: 2 },
      { label: "All Closed", value: 3 },
      { label: "All Overdue & Open", value: 4 },
      { label: "Unassigned", value: 5 },
    ],
    // ...(login_user_role === "EMPLOYEE" && {
    myViews: [
      { label: "My Open", value: 6 },
      { label: "My Closed", value: 7 },
      { label: "My Overdue & Open", value: 8 },
      { label: "Milestone I Follow", value: 9 },
      { label: "Milestone Created By Me", value: 10 },
    ],
    // }),
  };

  const handleFilterChange = (event) => {
    const value = event.target.value;
    setFilter(value);

    let filteredProjects;
    switch (value) {
      case "completed":
        filteredProjects = Milestone.filter(
          (project) => project.completion === 100,
        );

        break;
      case "recent":
        filteredProjects = Milestone; // Modify this to sort/filter based on recent access logic
        break;
      default:
        filteredProjects = Milestone;
    }

    setMilestone(filteredProjects);
  };
  const handleApplyFilter = (filteredData) => {
    setMilestone(
      // filteredData.map((project) => ({
      //   ...project,
      //   id: project.milestone_id, // Ensure DataGrid has a unique ID
      // }))
      filteredData.map((project) => ({
        ...project,
        id: project.task_id,
      })),
    );

    setShowFilter(false);
    setClearFilter(true);
  };

  const handleSearchChange = async (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    if (value) {
      await fetchSearchedMilestone(value);
    } else {
      await milestone_module_refetch();
    }
  };

  // Handle row click
  const handleRowClick = (params) => {
    if (params.row.isParent) return; // Prevent navigation for parent rows

    const { milestone_id, parent_id: project_id } = params.row;

    if (milestone_id && project_id) {
      navigate(
        `/projects/projectDetail/milestone/MilestoneDetail/${milestone_id}`,
      );
    }
  };

  // //console.log()("checking_milestone :", selectedTask);
  // //console.log()("checking_milestone :", Milestone);

  return (
    <>
      {/* Add  Project */}
      <Offcanvas
        show={showProject}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        {/* {showFilter && ( */}
        <Offcanvas.Body className="p-0">
          <AddMilestoneComponent
            // onApply={handleApplyFilter}
            // onClear={handleClearFilter}
            // onCancel={() => setShowFilter(false)}
            fetchMilestone={milestone_module_refetch}
            onClear={() => reset()} // Resets to initial values
            onCancel={() => setShowProject(false)}
          />
        </Offcanvas.Body>
        {/* )} */}
      </Offcanvas>

      {/* Add filter */}
      <Offcanvas
        show={showFilter}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        {/* {showFilter && ( */}
        <Offcanvas.Body className="p-0">
          <MilestoneFilterComponent
            // onApply={handleApplyFilter}
            // onClear={handleClearFilter}
            // onCancel={() => setShowFilter(false)}
            onApply={handleApplyFilter}
            onClear={() => reset()} // Resets to initial values
            onCancel={() => setShowFilter(false)}
          />
        </Offcanvas.Body>
        {/* )} */}
      </Offcanvas>

      <div style={{ height: "100%", width: "100%" }} className="bg-white p-3">
        {/* <div className="d-flex justify-content-between pb-2"> */}
        <Box
          className="d-flex justify-content-between"
          sx={{
            border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
            borderRadius: "6px",
            padding: "12px 16px",
            marginBottom: "16px",
            backgroundColor: isDarkMode ? "transparent" : "#fff",
          }}
        >
          <FormControl className="mt-1">
            {/* {login_user_role !== "EMPLOYEE" ? (
              <Select value={filter} onChange={handleFilterChange} displayEmpty>
                <label className="text-rgba-gray ps-3">Predefined Views</label>
                {filterOptions.predefined.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            ) : ( */}

            <Select value={filter} onChange={handleFilterChange} displayEmpty>
              <ListSubheader className="text-rgba-gray ps-3">Predefined Views</ListSubheader>
              {filterOptions.predefined.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}

              <ListSubheader className="text-rgba-gray ps-3">My Views</ListSubheader>
              {filterOptions.myViews.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
            {/* )} */}
          </FormControl>

          <div className="d-flex align-items-center gap-3">
            <SearchBar
              placeholder="Search milestone"
              searchTerm={searchTerm}
              onSearchChange={handleSearchChange}
            />
            {clearFilter && (
              <button
                type="button"
                className="addmore_btn"
                // onClick={fetchMilestone}
              >
                Clear filter
              </button>
            )}
            {login_user_role !== "CLIENT" && (
              // <button className="AddButton" onClick={handleShowProject}>

              //   {/* <CiCirclePlus className="text-rgbr-blue pro-icon-s" /> */}
              // </button>
              <Button
                className="rounded AddButton me-1 ms-1"
                onClick={handleShowProject}
              >
                Add Milestone
              </Button>
            )}

            {/* <button
              className="border-0 p-2 rounded-circle text-decoration-none project-icon-bg"
              onClick={handleShowFilter}
            >
              <CiFilter className="text-rgbr-blue pro-icon-s" />
            </button> */}
          </div>
        {/* </div> */}
        </Box>
        {milestone_module_loading ? (
          <Loader /> // Display loader while loading
        ) : (
          <Box>
            <DataGrid
              rows={rows}
              columns={columns}
              // onRowClick={handleRowClick}
              getRowId={(row) => row.id}
              disableColumnMenu
              disableColumnSorting
              disableColumnFilter
              disableColumnSelector
              pagination
              paginationModel={paginationModel}
              onPaginationModelChange={setPaginationModel}
              pageSizeOptions={[10, 20, 30, 40]}
              slots={{ noRowsOverlay: CustomNoRowsOverlay }}
              disableSelectionOnClick
              autoHeight
            />

            {/* Menu for Action Button Options */}
            <Menu
              anchorEl={menuAnchorEl}
              open={Boolean(menuAnchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem onClick={() => handleMenuClick(true)}>
                <CiViewList className="me-2" color="blue" />
                View Details
              </MenuItem>
              <MenuItem onClick={() => handleMenuClick(false)}>
                <CiViewList className="me-2" color="blue" />
                View Details in New Tab
              </MenuItem>
              <CommonDeleteDialog
                name="Milestone"
                statusName={selectedTask?.name}
                id={numericId}
                url="milestones/delete"
                refetchList={milestone_module_refetch}
                handleListClose={handleMenuClose}
              />
             <MenuItem
                onClick={() => {
                  setShowEditModal(true);
                  handleMenuClose();
                }}
              >
                <CiEdit className="me-2" color="blue" />
                Edit Milestone
              </MenuItem>
            </Menu>
          </Box>
        )}
      </div>
      <Modal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Milestone</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <form
              id="edit-milestone-form"
              onSubmit={handleEditSubmit(onEditSubmit)}
            >
              {/* Milestone Name */}
              <div className="mb-3">
                <label htmlFor="MilestoneName" className="form-label">
                  Milestone Name <span className="errorMsg">*</span>
                </label>
                <TextField
                  type="text"
                  placeholder="Enter milestone name"
                  className="form-control"
                  {...editRegister("MilestoneName", {
                    required: "Milestone name is required",
                  })}
                />
                {editErrors.MilestoneName && (
                  <span className="text-danger">
                    {editErrors.MilestoneName.message}
                  </span>
                )}
              </div>

              {/* Owner */}
              <div className="mb-3">
                <label htmlFor="owner" className="form-label">
                  Owner <span className="text-rgbr-red">*</span>
                </label>
                <FormControl fullWidth>
                  <Controller
                    name="owner"
                    control={editControl}
                    render={({ field }) => (
                      <Select
                        {...field}
                        IconComponent={ExpandMore}
                        displayEmpty
                        renderValue={(selected) =>
                          selected ? (
                            usersInProjects?.find(
                              (owner) => owner.user_id === Number(selected),
                            )?.name
                          ) : (
                            <span className="lightText">Select owner</span>
                          )
                        }
                      >
                        {usersInProjects?.map((user, index) => (
                          <MenuItem value={user.user_id} key={index}>
                            {user.name}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  />
                </FormControl>
              </div>
              <div className="row">
                {/* status */}
                <div className="mb-3 col-12">
                  <label htmlFor="owner" className="form-label">
                    Status <span className="text-rgbr-red">*</span>
                  </label>
                  <FormControl fullWidth>
                    <Controller
                      name="status_id"
                      control={editControl}
                      render={({ field }) => {
                        return (
                          <Select
                            {...field}
                            value={field.value || ""}
                            IconComponent={ExpandMore}
                            displayEmpty
                            renderValue={(selected) => {
                              console.log(
                                "renderValue selected:",
                                selected,
                                typeof selected,
                              );

                              if (!selected)
                                return (
                                  <span className="lightText">
                                    Select status
                                  </span>
                                );

                              const selectedStatus = fields?.find(
                                (s) => Number(s.id) === Number(selected),
                              );

                              return selectedStatus ? (
                                <span
                                  style={{
                                    color: selectedStatus.status_colour,
                                    fontWeight: 500,
                                  }}
                                >
                                  {selectedStatus.status_name}
                                </span>
                              ) : (
                                <span className="lightText">Select status</span>
                              );
                            }}
                          >
                            {fields?.map((status, index) => (
                              <MenuItem
                                sx={{
                                  color: status.status_colour,
                                  fontWeight: 500,
                                }}
                                value={Number(status.id)}
                                key={index}
                              >
                                {status.status_name}
                              </MenuItem>
                            ))}
                          </Select>
                        );
                      }}
                    />
                  </FormControl>
                </div>
              </div>

              {/* Start Date */}
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Start Date</label>
                  <Controller
                    name="StartDate"
                    control={editControl}
                    render={({ field }) => (
                      <DatePicker
                        format="DD/MM/YYYY"
                        {...field}
                        onChange={(date) => field.onChange(date)}
                        renderInput={(params) => (
                          <input className="form-control" {...params} />
                        )}
                      />
                    )}
                  />
                </div>

                {/* End Date */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">End Date</label>
                  <Controller
                    name="EndDate"
                    control={editControl}
                    render={({ field }) => (
                      <DatePicker
                        format="DD/MM/YYYY"
                        {...field}
                        onChange={(date) => field.onChange(date)}
                        renderInput={(params) => (
                          <input className="form-control" {...params} />
                        )}
                      />
                    )}
                  />
                </div>
              </div>
            </form>
          </LocalizationProvider>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="cancel_btn"
            onClick={() => setShowEditModal(false)}
          >
            Cancel
          </button>
          <button
            type="submit"
            form="edit-milestone-form"
            className="add_btn"
            disabled={editLoading}
          >
            {editLoading ? <BtnLoader /> : "Update"}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Milestone;
